import { createIcon } from '../createIcon';
import { ReactComponent as IconTimesCircleSolid } from '../svg/times-circle-solid.svg';

export default createIcon(IconTimesCircleSolid);
